import Vue from "vue";

export const apiGet = async (url, { ...data }) => {
  return await Vue.axios
    .get(url, { ...data })
    .then(res => {
      return Promise.resolve(res.data);
    })
    .catch(error => {
      throw error;
    });
};
